/**
 * Sort list
 * @private
 */
const sortItems = (materials) => {
  const items = materials.sort((a, b) => {
    if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
    if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
    return 0;
  });
  return items;
};


/**
 * Group by first letter
 * @private
 */
const groupAlpha = (arr) => {
  const data = arr.reduce((r, e) => {
    const ac = r;
    const group = e.name[0].toUpperCase();
    if (!ac[group]) {
      ac[group] = { group, children: [e] };
    } else {
      ac[group].children.push(e);
    }
    return ac;
  }, {});

  return Object.values(data);
};


/**
 * @param {*} materials
 * @returns {array} sorted and grouped materials
 */
const getAlphabeticMaterials = (materials) => {
  const sortedMaterials = sortItems(materials);
  return groupAlpha(sortedMaterials);
};


export {
  getAlphabeticMaterials as default
};
